import { render, staticRenderFns } from "./VariantPicker.vue?vue&type=template&id=1a1e4a5e&"
import script from "./VariantPicker.vue?vue&type=script&lang=js&"
export * from "./VariantPicker.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports